import React, { useState } from "react";

import AIDietNew from "./AIDietNew";
import AIExercise from "./AIExercise";

const AIHomePage = () => {
  const [exercise, setexercise] = useState(true);
  const [diet, setdiet] = useState(false);
  const [isexerciseactive, setisexerciseactive] = useState(true);
  const [isdietactive, setisdietactive] = useState(false);

  const exerciseHandler = () => {
    setexercise(true);
    setdiet(false);
    setisexerciseactive(true);
    setisdietactive(false);
  };

  const dietHandler = () => {
    setexercise(false);
    setdiet(true);
    setisexerciseactive(false);
    setisdietactive(true);
  };
  return (
    <div className="patient-diet-and-exercise-view-flex-div">
      <div className="patient-diet-and-exercise-view-width-div">
        <div className="patient-diet-and-exercise-view-main-div">
          <div
            className={
              isexerciseactive
                ? "new-que-home-div-sub-one-active-in-pres"
                : "new-que-home-div-sub-one-in-pres"
            }
            onClick={exerciseHandler}
          >
            AI Diet
          </div>

          <div
            className={
              isdietactive
                ? "new-que-home-div-sub-one-active-in-pres"
                : "new-que-home-div-sub-one-in-pres"
            }
            onClick={dietHandler}
          >
          AI Exercise
          </div>
        </div>
        <div>
          {exercise && <AIDietNew />}
          {diet && <AIExercise />}
        </div>
      </div>
    </div>
  );
};

export default AIHomePage;
